module.exports = window["Bernie_l10nBundle_he_IL"];